// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-bubble';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.576.576v16.848h16.848M5.04 4.392c0 .288.216.504.504.504s.504-.216.504-.504-.288-.432-.504-.432-.504.216-.504.432zm6.264 2.952c0 .432.288.72.72.72s.72-.288.72-.72-.288-.72-.72-.72-.72.288-.72.72zm3.168-4.968c0 .648.504 1.152 1.152 1.152s1.152-.504 1.152-1.152-.504-1.152-1.152-1.152c-.648.072-1.152.576-1.152 1.152z' />
    <path d='M8.136 12.96c0 .648.504 1.152 1.152 1.152s1.152-.504 1.152-1.152-.504-1.152-1.152-1.152-1.152.504-1.152 1.152zm-5.256.504c0 .936.72 1.656 1.656 1.656s1.656-.72 1.656-1.656-.72-1.656-1.656-1.656-1.656.72-1.656 1.656z' />
  </g>
);

export const viewBox = '0 0 18 18';
